import { render, staticRenderFns } from "./ContentTypeFactory.vue?vue&type=template&id=0bcd058a&"
import script from "./ContentTypeFactory.vue?vue&type=script&lang=ts&"
export * from "./ContentTypeFactory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports